import React, { useContext } from 'react';
import { Link, useLocation } from "react-router-dom";
import styles from "./Navbar.module.css"
import ProfileDrop from '../ProfileDrop/ProfileDrop'
import noteContext from '../Context/NoteContext';
import Icons, { TiMessages, IoMdNotificationsOutline, IoIosSearch, IoIosAddCircleOutline, CiFilter, CgProfile } from "../Icons";
import { SignInButton, useUser } from "@clerk/clerk-react";
import { BiMenu } from 'react-icons/bi';
import Logo from '../Logo/Logo';
import { IoMdClose } from 'react-icons/io';

export default function Navbar() {

    const {
        expenseList, setExpenseList,
        edittmp, setedittmp,
        ind, setind,
        categories, setCategories,
        isModal, setisModal,
        modalType, setModalType,
        allCat, setAllCat,
        isProfile, setIsProfile,
        Income, setIncome,
        Expense, setExpense,
        searchQuery, setSearchQuery,
        isSearch, setIsSearch,
        isMenuOpen, setIsMenuOpen,
        mobileSearch, setMobileSearch
    } = useContext(noteContext);

    const location = useLocation()
    const addValue = () => {
        setisModal(true)
        setModalType("addValue")
    }


    let title = "Dashboard"; // default

    if (location.pathname === "/Transctions") {
        title = "Transactions";
    } else if (location.pathname === "/Profile") {
        title = "Profile";
    } else if (location.pathname === "/Inbox") {
        title = "Inbox";
    }

    const { user } = useUser();
    return (
        <>

            {/* Navbar */}
            <div className={styles.Navbarx}>

                <div className={styles.mobileNavbar}>
                    {/* Logo */}
                    <div className={styles.Logo}><Logo /></div>
                    {/* Logo */}

                    {/* Page Title */}
                    <div className={styles.Navbar}>
                        <h1 className={styles.title}><b>{title}</b></h1>
                    </div>
                    {/* Page Title */}
                </div>
                {/* Navbar right */}
                <div className={styles.NavbarRight}>

                    {/* SearchBar */}
                    <div className={mobileSearch ? styles.phoneSearchBar : styles.searchBar}>
                        <div>
                            <input
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)} />

                            {/* (X) icon inside the search bar */}
                            {searchQuery && (
                                <span
                                    onClick={() => setSearchQuery("")}
                                    style={{ position: 'absolute', cursor: 'pointer' }}
                                    className={styles.Xicon}>
                                    ✕
                                </span>
                            )}
                        </div>
                    </div>
                    {/* SearchBar */}

                    {/* SearchIcon */}
                    <div style={{ color: "white" }}>
                        {mobileSearch ? <IoMdClose onClick={() => setMobileSearch(false)}
                            size={30}
                            style={{ color: "white", cursor: "pointer" }} /> :
                            <div className={styles.searchIcon} onClick={() => setMobileSearch(true)}><IoIosSearch size={30} /></div>
                        }
                        {/* SearchIcon */}
                    </div>



                    <Link to="/Inbox" className={styles.icon}><TiMessages /></Link>
                    <div>
                        <b className={styles.name}>
                            {user ? (user.fullName) : (
                                <SignInButton mode="modal">
                                    <span style={{ cursor: 'pointer' }}>Login</span>
                                </SignInButton>
                            )}
                        </b>
                    </div>
                    {/* Navbar right */}



                    {/* Profile */}

                    <div className={styles.profilemain} onClick={(e) => {
                        e.stopPropagation(); setIsProfile(!isProfile);
                    }} >

                        <img src={user ? user.imageUrl : "Profile.svg"} alt="Profile" className={styles.profileimg} />
                        <ProfileDrop isProfile={isProfile} setIsProfile={setIsProfile}>
                            <div style={{ display: "flex" }}>
                                <img src={user ? user.imageUrl : "profile.svg"} alt="" className={styles.profileimg} />
                                <div>
                                    <b>
                                        {user ? (user.fullName) : (
                                            <SignInButton mode="modal">
                                                <span className={styles.login}>Login</span>
                                            </SignInButton>
                                        )}
                                    </b>
                                </div>
                            </div>
                        </ProfileDrop>
                    </div>
                    {/* Profile */}
                    <div>
                        {isMenuOpen ? (
                            <div onClick={() => setIsMenuOpen(false)}>
                                <IoMdClose size={40} style={{ color: "white", cursor: "pointer" }} />
                            </div>
                        ) : (
                            <div className={styles.menu} onClick={() => {
                                setIsMenuOpen(true);
                                setMobileSearch(false);
                            }}>
                                <BiMenu size={40} style={{ color: "white" }} />
                            </div>
                        )}
                    </div>

                </div>
            </div>
            <div className={styles.addbar}>
                <button onClick={() => addValue()}><IoIosAddCircleOutline />Add Expense</button>
            </div>

            {/* Backdrop */}
            {isMenuOpen && <div className={styles.backdrop} onClick={() => { setIsMenuOpen(false) }}></div>}
            {/* Backdrop */}

            {/* Navbar */}
        </>
    )
}